import axios from 'axios'
import library from '../../../utils/Library'

export const EnableApplicationInstanceAppModule = async (body) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_authz') +
    '/enableApplicationInstanceAppModuleEAuthz'
  return await axios({
    url: URL,
    method: 'POST',
    data: body,
    headers: { Authorization: `Bearer ${TOKEN}` }
  })
}
